export default "__VITE_ASSET__Cfv9K52v__"